import { createFileRoute } from "@tanstack/react-router";
import { LearnHubPage } from "#/features/learn/components/learn-hub-page";

export const Route = createFileRoute("/ko/_app/learn/")({
	component: LearnHubPage,
});
